import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api, { ASSET } from "../../lib/api";
import { Store, Search, Package } from "lucide-react";

/**
 * Directory of all vendor storefronts (vetrine).
 * Route: /negozi
 */
export default function VendorStores() {
  const [stores, setStores] = useState([]);
  const [loading, setLoading] = useState(true);
  const [q, setQ] = useState("");

  useEffect(() => {
    api
      .get("/vendor/stores")
      .then((r) => setStores(r.data.stores || []))
      .catch(() => {})
      .finally(() => setLoading(false));
  }, []);

  const filtered = stores.filter((s) =>
    !q
      ? true
      : (s.store_name || "").toLowerCase().includes(q.toLowerCase()) ||
        (s.category || "").toLowerCase().includes(q.toLowerCase())
  );

  return (
    <div data-testid="vendor-stores-page" className="container-xl py-12">
      <div className="text-center max-w-2xl mx-auto mb-10">
        <div className="text-xs uppercase tracking-[0.3em] text-[hsl(var(--primary))] font-semibold mb-2">
          Le nostre aziende
        </div>
        <h1 className="editorial-heading text-4xl md:text-5xl">Vetrine dei Fornitori</h1>
        <p className="text-muted-foreground mt-3">
          Scopri i produttori italiani e i loro prodotti — al pezzo per te o a blocchi per il B2B.
        </p>
        <div className="mt-6 relative max-w-md mx-auto">
          <Search className="h-4 w-4 absolute left-3 top-1/2 -translate-y-1/2 text-muted-foreground" />
          <input
            data-testid="stores-search"
            value={q}
            onChange={(e) => setQ(e.target.value)}
            placeholder="Cerca un'azienda o categoria…"
            className="w-full pl-10 pr-4 py-3 border border-border rounded-sm bg-card focus:outline-none focus:border-[hsl(var(--primary))]"
          />
        </div>
      </div>

      {loading ? (
        <div className="text-center py-16 text-muted-foreground">Caricamento…</div>
      ) : filtered.length === 0 ? (
        <div className="text-center py-16 text-muted-foreground">
          Nessuna vetrina disponibile.{" "}
          <Link to="/azienda/registrati" className="text-[hsl(var(--primary))] hover:underline">
            Registra la tua azienda →
          </Link>
        </div>
      ) : (
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {filtered.map((s) => (
            <Link
              key={s.vendor_id}
              to={`/negozio/${s.store_slug}`}
              data-testid="store-card"
              className="group border border-border bg-card rounded-sm p-6 hover:shadow-lg hover:border-[hsl(var(--primary))] transition-all"
            >
              <div className="flex items-center gap-4">
                <div className="w-16 h-16 rounded-sm bg-[hsl(var(--muted))] border border-border flex items-center justify-center overflow-hidden shrink-0">
                  {s.logo_url ? (
                    <img src={ASSET(s.logo_url)} alt={s.store_name} className="w-full h-full object-contain" />
                  ) : (
                    <Store className="h-7 w-7 text-[hsl(var(--primary))]" />
                  )}
                </div>
                <div className="min-w-0">
                  <h3 className="font-serif text-lg text-foreground truncate">{s.store_name}</h3>
                  {s.category && (
                    <div className="text-xs text-muted-foreground truncate">{s.category}</div>
                  )}
                </div>
              </div>
              {s.store_description && (
                <p className="mt-4 text-sm text-muted-foreground line-clamp-2">{s.store_description}</p>
              )}
              <div className="mt-4 flex items-center gap-1.5 text-xs text-[hsl(var(--primary))] font-semibold">
                <Package className="h-3.5 w-3.5" />
                {s.product_count} prodotti · Visita la vetrina →
              </div>
            </Link>
          ))}
        </div>
      )}
    </div>
  );
}
